// extracted by mini-css-extract-plugin
export default {"cardsApp":"cards_cardsApp__sltvW"};